import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { API_URL } from '../../env'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import { ThreeCircles } from 'react-loader-spinner'
import { toast } from 'react-toastify'
import { numericFormatter, patternFormatter } from 'react-number-format'
import { Fade } from 'react-awesome-reveal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChartLine, faCreditCard, faEnvelope, faHome, faKey, faRightFromBracket, faRulerCombined, faUserCog, faUsers } from '@fortawesome/free-solid-svg-icons'
import '../../styles/Admin/Admin.css'
import AdminDiagnostic from './AdminDiagnostic'
import AdminCustomer from './AdminCustomer'
import AdminPayment from './AdminPayment'
import AdminStatistic from './AdminStatistic'
import InputSwitchSelector from '../Input/InputSwitchSelector'
import AdminContact from './AdminContact'
import Button from '../Utils/Button'
import Modal from '../Utils/Modal'
import InputText from '../Input/InputText'
import { sha512 } from 'js-sha512'
import { signOutStoreUser } from '../../store/user/userAction'

function Admin({ ip }) {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { adminRouter, id } = useParams()
    const userInfo = useSelector((state) => state.userReducer)
    const signOutUserStore = (userData) => dispatch(signOutStoreUser(userData))
    const [isLoading, setIsLoading] = useState(true)
    const [displayChangePasswordModal, setDisplayChangePasswordModal] = useState(false)
    const [adminRouterPrev, setAdminRouterPrev] = useState('diagnostic')
    const [diagnostics, setDiagnostics] = useState([])
    const [customers, setCustomers] = useState([])
    const [payments, setPayments] = useState([])


    const passwordOldRef = useRef(null)
    const [passwordOld, setPasswordOld] = useState("")
    const [passwordOldError, setPasswordOldError] = useState(false)
    const passwordNewRef = useRef(null)
    const [passwordNew, setPasswordNew] = useState("")
    const [passwordNewError, setPasswordNewError] = useState(false)
    const passwordNewConfirmationRef = useRef(null)
    const [passwordNewConfirmation, setPasswordNewConfirmation] = useState("")
    const [passwordNewConfirmationError, setPasswordNewConfirmationError] = useState(false)

    const switchSelectorData = [
        { label: <div><FontAwesomeIcon icon={faRulerCombined} className='switchSelectorIcon' /> Diagnostics</div>, value: 'diagnostic' },
        { label: <div><FontAwesomeIcon icon={faUsers} className='switchSelectorIcon' /> Clients</div>, value: 'customer' },
        { label: <div><FontAwesomeIcon icon={faCreditCard} className='switchSelectorIcon' /> Paiements</div>, value: 'payment' },
        { label: <div><FontAwesomeIcon icon={faEnvelope} className='switchSelectorIcon' /> Contacts</div>, value: 'contact' },
        { label: <div><FontAwesomeIcon icon={faChartLine} className='switchSelectorIcon' /> Statistiques</div>, value: 'statistic' }
    ]

    useEffect(() => {

        Promise.all([
            signInVerification(),
            getDiagnostics(),
            getCustomers(),
            getPayments()
        ]).then(() => {
            setIsLoading(false)
        })

    }, [])

    function displaySettings(type) {

        const settings = document.getElementById('adminSettings')
        if (type === 'display') {
            settings.style.height = '300px'
            settings.style.width = '400px'
        } else if (type === 'hide') {
            settings.style.height = '60px'
            settings.style.width = '100px'
        }

    }

    function signInVerification() {

        if (userInfo.tokenJWT) {
            axios.get(API_URL + 'user/signInVerification', {
                params: {
                    tokenJWT: userInfo.tokenJWT,
                }
            }).then().catch((error) => {
                if (error.response) {
                    var errorMessage = error.response.data.message
                    if (errorMessage === "ERROR_TOKENJWT") {
                        errorMessage = "Erreur lors de la connexion (tokenJWT)"
                    }
                }
                toast.error("Accès non autorisé")
                navigate('/authentification')
            })
        } else {
            toast.error("Accès non autorisé")
            navigate('/authentification')
        }

    }

    function getDiagnostics() {

        return axios.get(API_URL + 'diagnostic').then((response) => {
            response.data.map((item) => {
                item.createdAt = new Date(item.createdAt).toLocaleDateString('fr-FR', { year: 'numeric', month: 'numeric', day: 'numeric' })
                if (item.status === 'In progress') {
                    item.status = 'En cours'
                } else if (item.status === 'Completed') {
                    item.status = 'Terminé'
                } else if (item.status === 'Cancelled') {
                    item.status = 'Annulé'
                }
                item.customer.phone = patternFormatter(item.customer.phone, { format: '## ## ## ## ##' })
                item.payments.map((itemPayment) => {
                    if (itemPayment.amount.toString().split('.')[1] === '00') {
                        itemPayment.amount = numericFormatter(itemPayment.amount.toString(), { thousandSeparator: " ", decimalScale: 0, suffix: " €" })
                    } else {
                        itemPayment.amount = numericFormatter(itemPayment.amount.toString(), { thousandSeparator: " ", decimalScale: 2, suffix: " €" })
                    }
                    if (itemPayment.status === 'Unpaid') {
                        itemPayment.status = 'Non payé'
                    } else if (itemPayment.status === 'In progress') {
                        itemPayment.status = 'En cours'
                    } else if (itemPayment.status === 'Paid') {
                        itemPayment.status = 'Payé'
                    } else if (itemPayment.status === 'Refused') {
                        itemPayment.status = 'Refusé'
                    }
                    return itemPayment
                })
                item.type = item.type.join(',').replaceAll(',', ', ')
                return item
            })
            setDiagnostics(response.data)
        }).catch((error) => {
            console.log("error :\n" + JSON.stringify(error) + "\n\n")
        })

    }

    function getCustomers() {

        return axios.get(API_URL + 'customer').then((response) => {
            response.data.map((item) => {
                item.createdAt = new Date(item.createdAt).toLocaleDateString('fr-FR', { year: 'numeric', month: 'numeric', day: 'numeric' })
                item.updatedAt = new Date(item.updatedAt).toLocaleDateString('fr-FR', { year: 'numeric', month: 'numeric', day: 'numeric' })
                item.phone = patternFormatter(item.phone, { format: '## ## ## ## ##' })
                item.diagnostics.map((itemDiagnostic) => {
                    itemDiagnostic.createdAt = new Date(itemDiagnostic.createdAt).toLocaleDateString('fr-FR', { year: 'numeric', month: 'numeric', day: 'numeric' })
                    if (itemDiagnostic.status === 'In progress') {
                        itemDiagnostic.status = 'En cours'
                    } else if (itemDiagnostic.status === 'Completed') {
                        itemDiagnostic.status = 'Terminé'
                    } else if (itemDiagnostic.status === 'Cancelled') {
                        itemDiagnostic.status = 'Annulé'
                    }
                    itemDiagnostic.type = itemDiagnostic.type.join(',').replaceAll(',', ', ')
                    return itemDiagnostic
                })
                item.payments.map((itemPayment) => {
                    itemPayment.createdAt = new Date(itemPayment.createdAt).toLocaleDateString('fr-FR', { year: 'numeric', month: 'numeric', day: 'numeric' })
                    if (itemPayment.amount.toString().split('.')[1] === '00') {
                        itemPayment.amount = numericFormatter(itemPayment.amount.toString(), { thousandSeparator: " ", decimalScale: 0, suffix: " €" })
                    } else {
                        itemPayment.amount = numericFormatter(itemPayment.amount.toString(), { thousandSeparator: " ", decimalScale: 2, suffix: " €" })
                    }
                    if (itemPayment.status === 'Unpaid') {
                        itemPayment.status = 'Non payé'
                    } else if (itemPayment.status === 'In progress') {
                        itemPayment.status = 'En cours'
                    } else if (itemPayment.status === 'Paid') {
                        itemPayment.status = 'Payé'
                    } else if (itemPayment.status === 'Refused') {
                        itemPayment.status = 'Refusé'
                    }
                    return itemPayment
                })
                return item
            })
            setCustomers(response.data)
        }).catch((error) => {
            console.log("error :\n" + JSON.stringify(error) + "\n\n")
        })

    }

    function getPayments() {

        return axios.get(API_URL + 'payment').then((response) => {
            response.data.map((item) => {
                item.createdAt = new Date(item.createdAt).toLocaleDateString('fr-FR', { year: 'numeric', month: 'numeric', day: 'numeric' })
                item.updatedAt = new Date(item.updatedAt).toLocaleDateString('fr-FR', { year: 'numeric', month: 'numeric', day: 'numeric' })
                item.diagnostic.createdAt = new Date(item.diagnostic.createdAt).toLocaleDateString('fr-FR', { year: 'numeric', month: 'numeric', day: 'numeric' })
                if (item.amount.toString().split('.')[1] === '00') {
                    item.amount = numericFormatter(item.amount.toString(), { thousandSeparator: " ", decimalScale: 0, suffix: " €" })
                } else {
                    item.amount = numericFormatter(item.amount.toString(), { thousandSeparator: " ", decimalScale: 2, suffix: " €" })
                }
                if (item.status === 'Unpaid') {
                    item.status = 'Non payé'
                } else if (item.status === 'In progress') {
                    item.status = 'En cours'
                } else if (item.status === 'Paid') {
                    item.status = 'Payé'
                } else if (item.status === 'Refused') {
                    item.status = 'Refusé'
                }
                if (item.diagnostic.status === 'In progress') {
                    item.diagnostic.status = 'En cours'
                } else if (item.diagnostic.status === 'Completed') {
                    item.diagnostic.status = 'Terminé'
                } else if (item.diagnostic.status === 'Cancelled') {
                    item.diagnostic.status = 'Annulé'
                }
                return item
            })
            setPayments(response.data)
        }).catch((error) => {
            console.log("error :\n" + JSON.stringify(error) + "\n\n")
        })

    }

    function changePassword() {

        setIsLoading(true)
        var error = []
        if (!passwordOldRef.current.passwordValidation(passwordOld)) {
            error.push("L'ancien mot de passe est incorrect")
        }
        if (!passwordNewRef.current.passwordValidation(passwordNew)) {
            error.push("Le nouveau mot de passe est incorrect")
        }
        if (!passwordNewConfirmationRef.current.passwordValidation(passwordNewConfirmation)) {
            error.push("La confirmation du mot de passe est incorrect")
        }
        if (passwordNew !== passwordNewConfirmation) {
            error.push("Les mots de passe ne correspondent pas")
        }
        const passwordFormat = sha512(passwordOld).slice(3, 67)
        const passwordNewFormat = sha512(passwordNew).slice(3, 67)
        const passwordNewConfirmationFormat = sha512(passwordNewConfirmation).slice(3, 67)
        if (error.length > 0) {
            error.map((item) => toast.error(item))
            setIsLoading(false)
        } else {
            const toastId = toast.loading("Changement du mot de passe...")
            axios.put(API_URL + 'user/password', {
                password: passwordFormat,
                passwordNew: passwordNewFormat,
                passwordNewConfirmation: passwordNewConfirmationFormat,
            }).then((response) => {
                if (response.data === "PASSWORD_UPDATED") {
                    toast.update(toastId, { render: "Mot de passe changé", type: "success", isLoading: false, closeButton: true, closeOnClick: true, autoClose: 5000 })
                    setDisplayChangePasswordModal(false)
                    setPasswordOld("")
                    setPasswordNew("")
                    setPasswordNewConfirmation("")
                }
                setIsLoading(false)
            }).catch((error) => {
                if (error.response) {
                    var errorMessage = error.response.data.message
                    if (errorMessage === "ERROR_PASSWORD_CONFIRMATION") {
                        errorMessage = "La confirmation du mot de passe est incorrect"
                    } else if (errorMessage === "ERROR_USER_NOT_FOUND") {
                        errorMessage = "L'utilisateur est introuvable"
                    } else if (errorMessage === "ERROR_PASSWORD") {
                        errorMessage = "Le mot de passe est incorrect"
                    } else if (errorMessage === "ERROR_USER_UPDATE") {
                        errorMessage = "Erreur lors de la modification du mot de passe"
                    }
                }
                toast.update(toastId, { render: errorMessage, type: "error", isLoading: false, closeButton: true, closeOnClick: true, autoClose: 5000 })
                setIsLoading(false)
            })
        }
    }

    function signOut() {

        axios.get(API_URL + 'user/signOut').then((response) => {
            if (response.data === "DECONNECTED") {
                signOutUserStore()
                navigate('/')
            }
        })

    }

    if (isLoading) {
        return (

            <ThreeCircles visible={true} height={"100"} width={"100"} color={getComputedStyle(document.documentElement).getPropertyValue('--loaderDark')} wrapperClass={"loader"} />

        )
    } else {
        return (

            <>
                <div id='admin'>
                    <div id='adminSettings' onMouseEnter={() => displaySettings('display')} onMouseLeave={() => displaySettings('hide')}>
                        <FontAwesomeIcon icon={faUserCog} id='adminSettingsIcon' />
                        <div className='adminSettingsLink' onClick={() => setDisplayChangePasswordModal(true)}>
                            <FontAwesomeIcon icon={faKey} className='adminSettingsLinkIcon' />
                            Changer son mot de passe
                        </div>
                        <div id='adminSettingsButton'>
                            <Button theme={'dark'} rounded={true} icon={<FontAwesomeIcon icon={faHome} />} text={"Accueil"} onClick={() => navigate('/')} />
                            <Button theme={'danger'} rounded={true} icon={<FontAwesomeIcon icon={faRightFromBracket} />} text={"Déconnexion"} onClick={() => signOut()} />
                        </div>
                    </div>
                    <Modal
                        displayModal={displayChangePasswordModal}
                        setDisplayModal={setDisplayChangePasswordModal}
                        header={'Changer son mot de passe'}
                        body={
                            <>
                                <InputText
                                    type={'password'}
                                    theme={'dark'}
                                    ref={passwordOldRef}
                                    text={passwordOld} setText={setPasswordOld}
                                    textError={passwordOldError} setTextError={setPasswordOldError}
                                    icon={<FontAwesomeIcon icon={faKey} />}
                                    placeholder={"Ancien mot de passe"}
                                    passwordButtonVisible={true}
                                    maxLength={32}
                                    onPressEnter={() => passwordNewRef.current.inputTextRef.current.focus()}
                                />
                                <InputText
                                    type={'password'}
                                    theme={'dark'}
                                    ref={passwordNewRef}
                                    text={passwordNew} setText={setPasswordNew}
                                    textError={passwordNewError} setTextError={setPasswordNewError}
                                    icon={<FontAwesomeIcon icon={faKey} />}
                                    placeholder={"Nouveau mot de passe"}
                                    passwordButtonVisible={true}
                                    maxLength={32}
                                    onPressEnter={() => passwordNewConfirmationRef.current.inputTextRef.current.focus()}
                                />
                                <InputText
                                    type={'password'}
                                    theme={'dark'}
                                    ref={passwordNewConfirmationRef}
                                    text={passwordNewConfirmation} setText={setPasswordNewConfirmation}
                                    textError={passwordNewConfirmationError} setTextError={setPasswordNewConfirmationError}
                                    icon={<FontAwesomeIcon icon={faKey} />}
                                    placeholder={"Confirmer le mot de passe"}
                                    passwordButtonVisible={true}
                                    maxLength={32}
                                    onPressEnter={() => changePassword()}
                                />
                                <div id='adminChangePasswordButton'>
                                    {!isLoading ?
                                        <Button theme={'dark'} rounded={true} icon={<FontAwesomeIcon icon={faKey} />} text={"Changer le mot de passe"} onClick={() => changePassword()} />
                                        :
                                        <ThreeCircles visible={true} height={"40"} width={"40"} color={getComputedStyle(document.documentElement).getPropertyValue('--loaderDark')} />
                                    }
                                </div>
                            </>
                        }
                    />
                    <div id='adminSwitchSelector'>
                        <InputSwitchSelector
                            theme={'light'}
                            data={switchSelectorData}
                            value={adminRouter}
                            onChange={(value) => { setAdminRouterPrev(adminRouter); navigate('/administration/' + value + '/0') }}
                        />
                    </div>
                    {adminRouter === 'diagnostic' ?
                        <AdminDiagnostic
                            adminRouter={adminRouter}
                            setAdminRouterPrev={setAdminRouterPrev}
                            itemDisplay={id}
                            diagnostics={diagnostics} getDiagnostics={getDiagnostics}
                            customers={customers} getCustomers={getCustomers}
                            getPayments={getPayments}
                        />
                        : null
                    }
                    {adminRouter === 'customer' ?
                        <AdminCustomer
                            adminRouter={adminRouter}
                            adminRouterPrev={adminRouterPrev} setAdminRouterPrev={setAdminRouterPrev}
                            itemDisplay={id}
                            customers={customers} getCustomers={getCustomers}
                            getDiagnostics={getDiagnostics}
                            getPayments={getPayments}
                        />
                        : null
                    }
                    {adminRouter === 'payment' ?
                        <AdminPayment
                            adminRouter={adminRouter}
                            adminRouterPrev={adminRouterPrev} setAdminRouterPrev={setAdminRouterPrev}
                            itemDisplay={id}
                            payments={payments} getPayments={getPayments}
                            diagnostics={diagnostics} getDiagnostics={getDiagnostics}
                            customers={customers} getCustomers={getCustomers}
                        />
                        : null
                    }
                    {adminRouter === 'contact' ?
                        <AdminContact
                            adminRouter={adminRouter}
                            adminRouterPrev={adminRouterPrev} setAdminRouterPrev={setAdminRouterPrev}
                        />
                        : null
                    }
                    {adminRouter === 'statistic' ?
                        <Fade direction={'right'} duration={500}>
                            <AdminStatistic />
                        </Fade>
                        : null
                    }
                </div>
            </>

        )
    }

}

export default Admin